// List of 3rd party sytems, other than FieldEdge and ESC
module.exports = [
  {value: "acowin",                  label: "ACOWIN"},
  {value: "add systems",             label: "ADD Systems"},
  {value: "aptora",                  label: "Aptora"},
  {value: "ascente",                 label: "Ascente"},
  {value: "astea",                   label: "Astea"},
  {value: "automated integration",   label: "Automated Integration"},
  {value: "automated wireless",      label: "Automated Wireless (AWE)"},
  {value: "bizpro",                  label: "Bizpro"},
  {value: "blue cow",                label: "Blue Cow"},
  {value: "bluegrass",               label: "Bluegrass Technologies (MEPsoft)"},
  {value: "bottom line",             label: "Bottom Line Service System"},
  {value: "cargas energy",           label: "Cargas Energy"},
  {value: "cnc",                     label: "CNC"},
  {value: "coinsoa",                 label: "COINSOA"},
  {value: "computer ease",           label: "Computer Ease"},
  {value: "contractor 1",            label: "Contractor 1"},
  {value: "davisware",               label: "Davisware"},
  {value: "esys",                    label: "Esys"},
  {value: "fdms",                    label: "FDMS"},
  {value: "fieldease",               label: "FieldEase"},
  {value: "fieldlocate",             label: "FieldLocate"},
  {value: "fleetmatics",             label: "Fleetmatics"},
  {value: "fuel data systems",       label: "Fuel Data Systems"},
  {value: "housecall pro",           label: "HouseCall Pro"},
  {value: "jonas",                   label: "Jonas"},
  {value: "ifleet",                  label: "Ifleet"},
  {value: "mo.s.t.",                 label: "MO.S.T."},
  {value: "nav",                     label: "NAV"},
  {value: "netservicebooks",         label: "Netservicebooks"},
  {value: "nsb",                     label: "NSB"},
  {value: "oneplus",                 label: "OnePlus"},
  {value: "payzerware",              label: "Payzerware"},
  {value: "quantrac",                label: "Quantrac"},
  {value: "razorsync",               label: "RazorSync"},
  {value: "rg system",               label: "RG System"},
  {value: "s2000win",                label: "S2000Win"},
  {value: "sage",                    label: "Sage CRE 300"},
  {value: "sampro",                  label: "SAMPro (by Data-Basics)"},
  {value: "sawin",                   label: "SAWin"},
  {value: "service fusion",          label: "Service Fusion"},
  {value: "servicetitan",            label: "ServiceTitan"},
  {value: "servicom",                label: "Servicom"},
  {value: "servman",                 label: "ServMan"},
  {value: "shafers",                 label: "Shafer's"},
  {value: "smart service",           label: "Smart Service"},
  {value: "smartserv",               label: "SMARTSERV"},
  {value: "southware",               label: "Southware"},
  {value: "successware21",           label: "Successware21"},
  {value: "tms",                     label: "TMS"},
  {value: "total energy",            label: "Total Energy"},
  {value: "wintac",                  label: "Wintac"},
]
